import { createContext, useReducer } from "react";

// contex to render the updated data without refresh
// which means all components now have an access to the WP Sitecontext
export const ItemConfigsContext = createContext();

export const itemConfigReducer = (state, action) => {
  switch (action.type) {
    case "SET_ITEMCONFIG":
      return {
        itemConfigs: action.payload,
      };
    case "CREATE_ITEMCONFIG":
      return {
        itemConfigs: [action.payload, ...state.itemConfigs],
      };
    case "UPDATE_ITEMCONFIG":
      return {
        itemConfigs: state.itemConfigs.map((itemConfig) =>
          itemConfig._id === action.payload._id ? action.payload : itemConfig
        ),
      };
    case "DELETE_ITEMCONFIG":
      return {
        itemConfigs: state.itemConfigs.filter(
          (itemConfig) => itemConfig._id !== action.payload._id
        ),
      };
    default:
      return state;
  }
};

export const ItemConfigsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(itemConfigReducer, {
    itemConfigs: null,
  });
  return (
    <ItemConfigsContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ItemConfigsContext.Provider>
  );
};